module.exports = __webpack_public_path__ + "img/before-after-3.32e10603.png";